import { defineEntity, lifecycle, custom } from './_helpers.js';

export default defineEntity('asset', {
    reviewDue:       lifecycle(),
    'risk.linked':   custom({ scope: 'state' }),
    'risk.unlinked': custom({ scope: 'state' }),
    'threat.linked': custom({ scope: 'state' }),
    'threat.unlinked': custom({ scope: 'state' }),
    'control.linked': custom({ scope: 'state' }),
    'control.unlinked': custom({ scope: 'state' }),
    'vulnerability.linked': custom({ scope: 'state' }),
    'vulnerability.unlinked': custom({ scope: 'state' }),
    'process.linked': custom({ scope: 'state' }),
    'process.unlinked': custom({ scope: 'state' }),
    'vendor.linked': custom({ scope: 'state' }),
    'vendor.unlinked': custom({ scope: 'state' }),
    'pdInventory.linked': custom({ scope: 'state' }),
    'pdInventory.unlinked': custom({ scope: 'state' }),
    'license.linked': custom({ scope: 'state' }),
    'license.unlinked': custom({ scope: 'state' }),
    'disposal.linked': custom({ scope: 'state' }),
    'disposal.unlinked': custom({ scope: 'state' }),
    pendingDeleteApproved: custom({ scope: 'state' }),
    pendingDeleteRejected: custom({ scope: 'state' }),
    supportEndReminder: custom({ scope: 'state' }),
});
